<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            Ny kunde
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <div class="cell medium-6">
              <label>Kontotype *</label>

              <div class="radio-button-container">
                <ul>
                  <li>
                    <input id="Bedrift-0" name="Bedrift" type="radio" v-model="form.Bedrift" v-bind:value="false">
                    <label for="Bedrift-0">Privat</label>
                  </li>
                  <li>
                    <input id="Bedrift-1" name="Bedrift" type="radio" v-model="form.Bedrift" v-bind:value="true">
                    <label for="Bedrift-1">Bedrift</label>
                  </li>
                </ul>
              </div>
            </div>

            <TheSelectInput v-model="form.Brukerid" containerClassName="cell medium-6" label="Kundeansvarlig" name="Brukerid" required v-validate="'required'" :items="instillinger.bruker"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset v-if="form.Bedrift">
          <div class="grid-x grid-padding-x">
            <h2>Bedrift</h2>

            <TheTextInput containerClassName="cell medium-6" label="Frimanavn" name="FirmaNavn" v-model.trim="form.FirmaNavn" maxlength="100" required v-validate="'required|max:100'"/>
            <TheTextInput containerClassName="cell medium-6" label="Org nr" name="Mvanr" v-model.trim="form.Mvanr" maxlength="25" v-validate="'max:25'"/>
          </div>
        </fieldset>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell medium-2" label="Tittel" name="Tittel" v-model.trim="form.Tittel" maxlength="50" v-validate="'max:50'"/>
            <TheTextInput containerClassName="cell medium-5" label="Fornavn" name="Fnavn" v-model.trim="form.Fnavn" maxlength="50" required v-validate="'required|max:50'"/>
            <TheTextInput containerClassName="cell medium-5" label="Etternavn" name="Enavn" v-model.trim="form.Enavn" maxlength="50" required v-validate="'required|max:50'"/>

            <TheTextInput containerClassName="cell large-12" label="E-post" name="Email" v-model.trim="form.Email" v-validate="'email|kundeEmailUnique'">
              <label slot="label" slot-scope="props" :for="props.id">
                {{props.label}} <span v-if="emailcheck"> søker...</span>
              </label>
            </TheTextInput>

            <TheTextInput containerClassName="cell medium-4" label="Kontonummer" name="Kontonr" v-model.trim="form.Kontonr" v-validate="'min:11|max:11'"/>
            <TheTextInput containerClassName="cell medium-4" label="SWIFT" name="Swift" v-model.trim="form.Swift" maxlength="40" v-validate="'max:40'"/>
            <TheTextInput containerClassName="cell medium-4" label="IBAN" name="Iban" v-model.trim="form.Iban" maxlength="40" v-validate="'max:40'"/>
            <TheTextInput containerClassName="cell medium-12" label="Betalingsinfo" name="Betalings_info" v-model.trim="form.Betalings_info" maxlength="255" v-validate="'max:255'"/>

            <!-- Phone fields -->
            <ThePhoneInput containerClassName="cell large-4" label="Mobil" name="Mobil" v-model.trim="form.Mobil" maxlength="20" v-validate="'max:20'"/>
            <ThePhoneInput containerClassName="cell large-4" label="Tlf. Privat" name="Tlfprivat" v-model.trim="form.Tlfprivat" maxlength="20" v-validate="'max:20'"/>
            <ThePhoneInput containerClassName="cell large-4" label="Tlf. Arbeid" name="Tlfarbeid" v-model.trim="form.Tlfarbeid" maxlength="20" v-validate="'max:20'"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KundeService from '@/services/KundeService'
import DummyCache from '@/plugins/dummy-cache.js'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCardCreateModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      form: {},
      instillinger: {
        bruker: []
      },
      loading: true,
      emailcheck: false,
      emailsCache: null
    }
  },
  created () {
    // Add the kunde email unique rule to our validator
    this.$validator.extend('kundeEmailUnique', {
      validate: this.uniqueEmailCheck,
      getMessage: (field, params, data) => data ? data.message : 'Kunde med denne epost finnes allerede'
    })

    // Create an emails cache container, so we don't have to do api requests if same email is sent tvice...
    this.emailsCache = new DummyCache()

    // Set form not submittable
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  methods: {
    makeFormItem: function () {
      let defaults = {
        Bedrift: false,
        Sperret: 'F',
        SendLagerleieinfo: 0,
        Arsavtale: 0,
        AktivertK: null,
        AktivertV: null,
        AktivertN: null,
        Landkode: 'NO',
        Legtype: 0,
        Legitimert: false,
        Leverandor: 'F',
        Sprak: 'nor-NO',
        Brukerid: this.$store.getters.getUser.Brukerid
      }

      // Apply default values to Kunde
      this.$helpers.setObjectValues(defaults, this.kunde)

      // Clone kunde to the form object
      this.form = this._.clone(this.kunde)
    },
    fetch: function () {
      this.loading = true

      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.bruker.unshift({key: this.form.Brukerid, val: 'Laster...'})

      KundeService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.bruker = data.bruker
          this.instillinger.bruker.unshift({key: 0, val: 'Velg kundeansvarlig', disabled: true})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.loading = false

          // Now submittable again
          this.setFormLoading(false)
        })
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // No errors, so try to save
            KundeService.save(null, this.form)
              .then((response) => {
                // Update this.kunde with the response data
                this.$helpers.softClone(response.data, this.kunde)

                // And re create the form item
                this.makeFormItem()

                // Emit kunde save ok event
                bus.$emit('kunde_form_saved', response.data)

                // Show success alert
                this.$helpers.showSuccessAlert('Kunde er lagret')
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    uniqueEmailCheck: function (value) {
      return new Promise(resolve => {
        // Start email check
        this.emailcheck = true
        let promise = null

        // See if we have a cached email
        if (!(promise = this.emailsCache.get(value))) {
          promise = KundeService.findByEmail(value)
          this.emailsCache.set(value, promise)
        }

        // Now do the resolve/reject logic
        promise
          .then((response) => {
            if (response.data && response.data.Email === value) {
              resolve({valid: false, data: {message: 'Kunde med denne epost finnes allerede'}})
            } else {
              resolve({valid: true})
            }
          })
          .catch(() => {
            resolve({valid: true})
          })
          .then(() => {
            this.emailcheck = false
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardCreateModal.vue